import { UserInfo } from "@app/user/UserContext";
import Features from "@app/feature-flags/features";
import Roles from "@app/user/roles";

export function networkPortfolioManagementViewStorageKey(user: UserInfo): string {
  return `${user.userId}_networkPortfolioManagementDashboardView`;
}

export function networkPortfolioManagementStyleStorageKey(user: UserInfo): string {
  return `${user.userId}_networkPortfolioManagementDashboardStyle`;
}

/**
 * Eligibility for the Project Dashboard opt-in toggle: PublicFlagOn OR (BetaRoleAssigned AND BetaFlagOn).
 * This only controls whether the toggle is offered, not the user's active view.
 */
export function isNetworkPortfolioManagementEligible(enabledFeatureFlags: Set<string>, userRoles: string[]): boolean {
  const publicFlagOn = enabledFeatureFlags.has(Features.PROJECT_ARGUS_PROJECT_DASHBOARD_PUBLIC);
  const betaFlagOn = enabledFeatureFlags.has(Features.PROJECT_ARGUS_PROJECT_DASHBOARD_BETA);
  const betaRoleAssigned = userRoles.includes(Roles.PROJECT_ARGUS_PROJECT_DASHBOARD_BETA);
  return publicFlagOn || (betaRoleAssigned && betaFlagOn);
}

/**
 * Whether the Project Dashboard is still in its beta rollout stage for this user: eligible for the
 * toggle but not yet at general availability. Drives the "Beta" badge — shown only while Public is
 * off, since Public (general availability) supersedes Beta.
 */
export function isNetworkPortfolioManagementBeta(enabledFeatureFlags: Set<string>, userRoles: string[]): boolean {
  return isNetworkPortfolioManagementEligible(enabledFeatureFlags, userRoles)
    && !enabledFeatureFlags.has(Features.PROJECT_ARGUS_PROJECT_DASHBOARD_PUBLIC);
}
